import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Postedlocs = () => {
  const [loc, setLoc] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Drag states kept as‑is
  const [isDragMode, setIsDragMode] = useState(false);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [dragEnabledId, setDragEnabledId] = useState(null);

  useEffect(() => {
    const fetchlocs = async () => {
      try {
        const res = await axios.get('/api/locationlist');
        setLoc(res.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching locs:', error);
        setLoading(false);
      }
    };

    fetchlocs();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box style={styles.pageWrapper}>
      <div style={styles.pageHeaderRow}>
        <div>
          <h1 style={styles.pageTitle}>Units &amp; Locations</h1>
          <p style={styles.pageSubtitle}>
            View all production units, warehouses, and associated facilities in one place.
          </p>
        </div>
        <button
          style={styles.primaryButton}
          onClick={() => navigate('/dashboard/locations/addloc')}
        >
          + Add Location
        </button>
      </div>

      {loc.length === 0 ? (
        <div style={styles.emptyState}>
          <p style={styles.emptyTitle}>No locations added yet</p>
          <p style={styles.emptyText}>
            Start by adding your first unit or facility to keep track of all locations.
          </p>
        </div>
      ) : (
        <div style={styles.grid}>
          {loc.map((unit) => (
            <div key={unit._id} style={styles.card}>
              <div style={styles.imageWrapper}>
                <img
                  src={unit.imageUrl}
                  alt={unit.title || 'Location image'}
                  style={styles.image}
                />
              </div>

              <div style={styles.cardBody}>
                <h4 style={styles.cardTitle}>{unit.title}</h4>
                <p style={styles.cardDescription}>{unit.description}</p>

                <div style={styles.metaRow}>
                  <span style={styles.metaLabel}>Location URL:</span>
                  <a
                    href={unit.mapurl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.metaLink}
                  >
                    {unit.mapurl}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </Box>
  );
};

const styles = {
  pageWrapper: {
    padding: '24px',
    boxSizing: 'border-box',
  },
  pageHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: '24px',
    gap: '16px',
  },
  pageTitle: {
    fontSize: '28px',
    fontWeight: 600,
    margin: 0,
    color: '#111827',
  },
  pageSubtitle: {
    marginTop: '6px',
    marginBottom: 0,
    fontSize: '14px',
    color: '#6b7280',
  },
  primaryButton: {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  border: 'none',
  padding: '0.875rem 1.75rem',
  borderRadius: '12px',
  fontSize: '1rem',
  fontWeight: '600',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  transition: 'all 0.3s ease',
  boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '20px',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '14px',
    overflow: 'hidden',
    boxShadow: '0 10px 24px rgba(15,23,42,0.08)',
    border: '1px solid #e5e7eb',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '260px',
  },
  imageWrapper: {
    width: '100%',
    paddingTop: '56.25%', // 16:9
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: '#f3f4f6',
  },
  image: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  cardBody: {
    padding: '14px 16px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  cardTitle: {
    margin: 0,
    fontSize: '16px',
    fontWeight: 600,
    color: '#111827',
  },
  cardDescription: {
    margin: 0,
    fontSize: '13px',
    color: '#4b5563',
    lineHeight: 1.5,
  },
  metaRow: {
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    fontSize: '12px',
  },
  metaLabel: {
    fontWeight: 500,
    color: '#6b7280',
  },
  metaLink: {
    color: '#2563eb',
    textDecoration: 'none',
    wordBreak: 'break-all',
  },
  emptyState: {
    marginTop: '40px',
    padding: '32px',
    borderRadius: '16px',
    border: '1px dashed #d1d5db',
    textAlign: 'center',
    backgroundColor: '#f9fafb',
  },
  emptyTitle: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 600,
    color: '#111827',
  },
  emptyText: {
    marginTop: '6px',
    marginBottom: 0,
    fontSize: '14px',
    color: '#6b7280',
  },
};

export default Postedlocs;



// import React, { useEffect, useState, useCallback } from 'react';
// import axios from 'axios';
// import { Box, Card, CardContent, Typography, Grid, CircularProgress } from '@mui/material';
// import { useNavigate } from 'react-router-dom';

// const Postedlocs = () => {
//   const [loc, setLoc] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//    // Drag and drop state
//   const [isDragMode, setIsDragMode] = useState(false);
//   const [draggedIndex, setDraggedIndex] = useState(null);
//   const [dragOverIndex, setDragOverIndex] = useState(null);
//    const [dragEnabledId, setDragEnabledId] = useState(null);

//   useEffect(() => {
//     const fetchlocs = async () => {
//       try {
//         const res = await axios.get('/api/locationlist');
//         setLoc(res.data);
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching locs:", error);
//         setLoading(false);
//       }
//     };

//     fetchlocs();
//   }, []);

  

//   if (loading) return <CircularProgress />;

//   return (
//     <Box p={3}>
//         <h1 style={styles.pageTitle}>Units and Locations</h1>
//           <div style={styles.contentCard}>
//             <div style={styles.cardHeader}>
            
//               <button style={styles.primaryButton} onClick={() => navigate('/dashboard/locations/addloc')}>
//                 Add Location
//               </button>
//             </div>
//             {loc.map((unit) => (
//                     <div key={unit._id} 
//                     style={styles.blogPost}
                 
//                     >
           
//                 <h4 style={styles.blogTitle}>{loc.title}</h4>
              
//                 <img
//                           src={unit.imageUrl}  
//                           alt="Uploaded"
//                           style={{ width: '100%', maxWidth: '400px', borderRadius: '8px', marginTop:'10px' }}
//                  />
//                 <p style={styles.blogMeta}><strong>Description:</strong> {unit.description}</p>
//                 <p style={styles.blogMeta}><strong>Location URL:</strong> {unit.mapurl}</p>
               
//               </div>
//             ))}
//           </div>
//     </Box>
//   )};

// const styles = {

// contentCard: {
//     backgroundColor: 'white',
//     borderRadius: '8px',
//     boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
//     border: '1px solid #e5e7eb',
//     padding: '24px',
//     marginBottom: '24px'
//   },
//   cardHeader: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '16px'
//   },
//   cardTitle: {
//     fontSize: '18px',
//     fontWeight: '600',
//     margin: 0
//   },
//   primaryButton: {
//     padding: '8px 16px',
//     backgroundColor: '#2563eb',
//     color: 'white',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     fontWeight: '500'
//   },
//    blogPost: {
//     borderLeft: '4px solid #3b82f6',
//     paddingLeft: '16px',
//     paddingTop: '8px',
//     paddingBottom: '8px',
//     marginBottom: '12px'
//   },
//   blogTitle: {
//     fontWeight: '500',
//     margin: '0 0 4px 0'
//   },
//   blogMeta: {
//     fontSize: '14px',
//     color: '#6b7280',
//     margin: 0
//   },
// }


// export default Postedlocs;